module.exports = __webpack_public_path__ + "img/9.a69a288c.png";